import _ from "lodash";
import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import { useAuth } from "./context/auth-context";
import { useConfig } from "./context/config-context";

import { applyCssVariables } from "./services/cssVariableService";
import { loadFonts, preloadFonts } from "./services/fontService";

import NotFoundPage from "./pages/not-found-page";

function App() {
  let { user } = useAuth();
  const siteConfig = useConfig();

  useEffect(() => {
    applyCssVariables(siteConfig.cssVariables);
    preloadFonts(siteConfig.fontVariables).then(() =>
      loadFonts(siteConfig.fontVariables)
    );
  }, [siteConfig]);

  const RequireAuth = ({ allowedRoles }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/not-found" replace />;
    }

    return <Outlet />;
  };

  const AuthRoute = ({ children }) => {
    return user ? <Navigate replace to="/" /> : children;
  };

  const PublicRoute = ({ children }) => {
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        {_.keys(siteConfig.routes).map((route) => {
          const routeConfig = siteConfig.routes[route];
          const isPrescriberRoute = routeConfig.path.startsWith('/prescriber-access');
          const isReportAccessRoute = routeConfig.path.startsWith('/report-access');

          return (
            <Route
              key={route}
              path={routeConfig.path}
              element={
                routeConfig.private ? (
                  <RequireAuth allowedRoles={routeConfig.access} />
                ) : isPrescriberRoute || isReportAccessRoute ? (
                  <PublicRoute>{routeConfig.element}</PublicRoute>
                ) : (
                  <AuthRoute>{routeConfig.element}</AuthRoute>
                )
              }
            >
              {routeConfig.private && (
                <Route path={routeConfig.path} element={routeConfig.element} />
              )}
            </Route>
          );
        })}

        <Route
          path="*"
          element={
            user ? (
              <NotFoundPage />
            ) : (
              <Navigate replace to={siteConfig.routes.login.path} />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
